import { useEffect, useState } from 'react';
import { fetchUserDevelopmentPlan, fetchCourseDevelopmentPlan } from 'Api/developmentPlanMainPage';

const useEmployee = (setIsLoading, startDate, endDate) => {
  const [terminal, setTerminal] = useState('');
  const [department, setDepartment] = useState('');
  const [jobTitle, setJobTitle] = useState('');
  const [employees, setEmployees] = useState([]);
  const [employee, setEmployee] = useState('');
  const [courses, setCourses] = useState([]);
  const [course, setCourse] = useState('');
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(offset);
  const [isByUsers, setIsByUsers] = useState(true);
  const [dataToExport, setDataToExport] = useState([]);

  const formatDate = date => {
    if (date === null) {
      return null;
    }

    const year = date !== null ? date.getFullYear().toString() : null;
    const month = date !== null ? (date.getMonth() + 1).toString() : null;
    const day = date !== null ? date.getDate().toString() : null;

    return new Date(`${year}-${month}-${day}`);
  };

  useEffect(() => {
    const formatedStartDate = formatDate(startDate);
    const formatedEndDate = formatDate(endDate);

    if (isByUsers) {
      fetchUserDevelopmentPlan({
        name: employee,
        jobTitle,
        department,
        terminal,
        startDate: formatedStartDate,
        endDate: formatedEndDate,
        limit,
        offset,
      }).then(data => {
        setIsLoading(false);
        setEmployees(data.employees);
        setCount(data.count);
      });

      fetchUserDevelopmentPlan({
        name: employee,
        jobTitle,
        department,
        terminal,
        startDate: formatedStartDate,
        endDate: formatedEndDate,
        limit: null,
        asObject: true,
      }).then(data => {
        setDataToExport(data.employees);
      });
    } else {
      setIsLoading(true);
      fetchCourseDevelopmentPlan({ name: course, limit, offset }).then(data => {
        setIsLoading(false);

        setCourses(data.courses);
        setCount(data.count);
      });
      fetchCourseDevelopmentPlan({
        name: course,
        limit: null,
        offset,
        asObject: true,
      }).then(data => {
        setDataToExport(data.courses);
      });
    }
  }, [limit, offset, terminal, department, jobTitle, isByUsers, employee, course, endDate]);

  return {
    setTerminal,
    setDepartment,
    setJobTitle,
    employees,
    setLimit,
    setOffset,
    limit,
    offset,
    count,
    setEmployee,
    page,
    setPage,
    isByUsers,
    setIsByUsers,
    courses,
    setCourse,
    dataToExport,
  };
};

export default useEmployee;
